<template>
  <div class="d-success-dialog">
    <Dialog
      v-if="cashResult.isShow && cashResult.type > 0"
      v-model="cashResult.isShow"
      confirmText="做任务得更多现金"
      :show-footer="true"
      @close="handleClose"
      @confirm="handleConfirm"
    >
      <div class="public-result-content">
        <div class="icon"></div>
        <p class="txt">恭喜你提现成功</p>
      </div>
    </Dialog>

    <Dialog
      v-if="cashResult.isShow && cashResult.type === 0"
      v-model="cashResult.isShow"
      title="随机提现成功"
      confirmText="做任务得更多现金"
      :show-footer="true"
      @close="handleClose"
      @confirm="handleConfirm"
    >
      <div class="public-result-content">
        <div class="res-bg">
          <div class="display">
            <div class="random-scroll">
              <div class="scroll-wrapper">
                <div class="marquee">
                  <div
                    v-for="(num, index) in visibleNumbers"
                    :key="index"
                    class="number"
                  >
                    {{ num }}
                  </div>
                </div>
              </div>
            </div>
            <div class="yuan">元</div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '@/v2-components/dialog'

export default {
  props: {
    cashResult: {
      type: Object,
      default: () => {
        return {
          type: 0,
          isShow: false,
          realMount: 0,
        }
      },
    },
  },
  components: { Dialog },
  data() {
    return {
      visibleNumbers: [], // 当前可见的数字
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.cashResult.type === 0 && this.cashResult.isShow) {
        this.generateRandomNumbers(10, this.cashResult.realMount)
      }
    })
  },
  mounted() {},

  methods: {
    generateRandomNumbers(count, target) {
      const numbers = [target]
      for (let i = 0; i < count; i++) {
        numbers.push((Math.random() * 0.2).toFixed(2)) // 生成随机数
      }
      this.visibleNumbers = numbers
    },
    handleClose() {
      this.$emit('close')
    },
    handleConfirm() {
      this.$router.push({ path: '/' })
    },
  },
}
</script>
<style lang="less">
.d-success-dialog {
  .m-dialog .dialog-container .dialog-footer .btn {
    font-size: 28px;
  }
  .m-dialog .dialog-container .dialog-title {
    margin-bottom: 36px;
    padding-left: 16px;
    line-height: 32px;
    padding-top: 48px;
  }
  .public-result-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .icon {
      .wh(276px, 116px);
      .bgCover('../../assets/v2/cash/success.png');
      margin-top: 60px;
      margin-bottom: 36px;
    }
    .txt {
      padding-bottom: 12px;
      // font-family: AlimamaFangYuanTiVF-Thin;
      font-weight: 600;
      font-size: 32px;
      color: rgba(0, 0, 0, 0.8);
      text-align: center;
      line-height: 32px;
    }
    .res-bg {
      width: 100%;
      height: 144px;
      border-radius: 24px 24px 24px 24px;
      background-color: rgba(0, 0, 0, 0.03);
      display: flex;
      align-items: center;
      justify-content: center;
      .display {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
        height: 144px;
        font-size: 32px;
        width: 200px;
        .yuan {
          line-height: 144px;
          padding-left: 10px;
          font-size: 28px;
          color: rgba(0, 0, 0, 0.4);
        }
        .random-scroll {
          width: 100px; /* 容器宽度 */
          height: 144px; /* 容器高度，和滚动单个数字的高度一致 */
          overflow: hidden; /* 隐藏溢出的内容 */
          text-align: center;
          position: relative;
        }

        .scroll-wrapper {
          height: 144px; /* 和单个数字高度一致 */
          position: relative;
          overflow: hidden;
        }

        .number {
          height: 144px; /* 每个数字高度 */
          line-height: 100px; /* 数字垂直居中 */
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 48px;
          color: #fdb03e;
          font-family: DIN Alternate, DIN Alternate;
        }
      }
    }
  }
  .marquee {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    animation: marquee 2s linear;
  }

  @keyframes marquee {
    0% {
      transform: translateY(-100%);
    }
    50% {
      transform: translateY(-40%);
    }
    100% {
      transform: translateY(0);
    }
  }
}
</style>
